import { Box, styled } from "@mui/material";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSideBar";

const Wrapper = styled(Box)(({ theme }) => ({
  height: "100%",
  width: "100%",
  maxWidth: 1500,
  marginTop: "10px",
  paddingLeft: 0,
  [theme.breakpoints.down("md")]: {
    width: "100%",
    marginLeft: 0,
    paddingLeft: "2rem",
    paddingRight: "2rem",
  },
}));

interface Props {
  children: React.ReactNode
}
const SideBarAndChildrenWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  gap: "20px",


}));
const DashboardLayout = ({ children }: Props) => {
  const [showMobileSideBar, setShowMobileSideBar] = useState(false);

  return (
    <SideBarAndChildrenWrapper>
      <DashboardSidebar
        showMobileSideBar={showMobileSideBar}
        closeMobileSideBar={() => setShowMobileSideBar(false)}
      />

      <Wrapper>
        <DashboardNavbar
          setShowMobileSideBar={() => setShowMobileSideBar((state) => !state)}
        />
        {children || <Outlet />}
      </Wrapper>
    </SideBarAndChildrenWrapper>
  );
};

export default DashboardLayout;
